export default function () {
  return {
    authenticated: false,
    user: null,
    language: 'gb'
  }
}